import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { AuthenticationService } from './authentication.service';
import { ApiResponse } from 'src/app/shared/interfaces/api-response.interface';
import { CartaoCredBandeira } from 'src/app/shared/models/cartao-cred-bandeira';

@Injectable({
  providedIn: 'root'
})
export class CartaoCredBandeirasService {
  constructor(
    private _httpClient: HttpClient,
    private _authService: AuthenticationService
  ) { }

  private get base() {
    return `${this._authService.baseUrl}/CartaoCredBandeiras`;
  }

  public obterCartaoCredBandeiras() {
    return this._httpClient.get<ApiResponse<CartaoCredBandeira[]>>(this.base);
  }
}
